import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Card, Button, Form } from 'reactstrap';
import { TableComponent } from './TableComponent';
export const ModalExamsEmail = (props) => {

    const {
        toggleExamEmail, toggleListExamEmail, typeModalExamEmail = "viewExamEmail", modalExamsEmail, dataExams,
        handleCheckProfile, handleCheckAll, Impresionbyexam, loading, handleCheckAllProfile, handleSendExam, handleFindExam
    } = props;

    return (
        <Modal isOpen={modalExamsEmail} toggle={toggleListExamEmail} backdrop='static' keyboard={false} centered={true} className="modal-lg" >
            <ModalHeader toggle={toggleListExamEmail} className="bg-primary">
                Listado de examenes:
            </ModalHeader>
            {
                typeModalExamEmail === "viewExamEmail" ?
                    <ModalBody>
                        <Card className='shadow' >
                                    <TableComponent
                                        key={"table"}
                                        indexs={dataExams}
                                        handleCheckProfile={handleCheckProfile}
                                        handleCheckAll={handleCheckAll}
                                        handleCheckAllProfile={handleCheckAllProfile}
                                    />
                        </Card>
                    </ModalBody>
                    : ""
            }
            <ModalFooter>
                <Button size='sm' outline color='primary' type='button' onClick={handleFindExam} className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    Siguiente
                </Button>
                <Button size='sm' className='btn-air-light' outline color='danger' type='button' onClick={toggleListExamEmail}>Cancelar</Button>
            </ModalFooter>

        </Modal>
    )
}